import { request_list } from '@/commons/hpod';
import Vue from 'vue';
const endpoint = 'tracking'

// initial state
const state = {
    loading: false,
    all: {},
    track_items: {},
    listOfDay: {},
    selected: {
        id: 0,
        TransactionCode: '',
        FeeShip: 0,
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getListTracking({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('tracking/find', data => {
            commit('setListTracking', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    }
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setListTracking(state, data) {
        state.track_items = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
